import imageUrlBuilder from "@sanity/image-url";
import { sanityClient } from "../../../sanity/lib/client";

const builder = imageUrlBuilder(sanityClient);

// lib/mapToJsonLd.ts
export function mapToJsonLd(input: Record<string, any> | Record<string, any>[]) {
    function transform(obj: any): any {
        if (Array.isArray(obj)) {
            return obj.map(transform);
        }

        if (obj && typeof obj === "object") {
            const newObj: Record<string, any> = {};
            for (const [key, value] of Object.entries(obj)) {
                if (key === "type") {
                    newObj["@type"] = transform(value);
                } else if (key === "id") {
                    newObj["@id"] = transform(value);
                } else if (key === 'image') {
                    newObj[key] = builder.image((value as any).asset._ref).url();
                } else if (key === 'logo') {
                    newObj[key] = builder.image((value as any).asset._ref).url();
                } else if (key === "_type" || key === "_key") {
                    continue; // Skip these keys since they are not needed in JSON-LD
                } else {
                    newObj[key] = transform(value);
                }
            }
            return newObj;
        }

        return obj;
    }

    const transformed = transform(input);

    if (Array.isArray(input)) {
        return {
            "@context": "https://schema.org",
            "@graph": transformed,
        };
    }

    return {
        "@context": "https://schema.org",
        ...transformed,
    };
}
